module.exports = __webpack_public_path__ + "static/media/radio_s.dc67c68d.svg";